<template>
  <tr>
    <td>
      {{ index + 1 }}    
    </td>
    <td width="80%">
      <div class="form-field select2">
        <div class="select2-field">
          <v-select
            @search="onSearchItem"
            :id="'item_' + index"
            @input="inputItem"
            :options="items"
            :tooltip="selectedItem != null ? selectedItem.nombre : ''"
            placeholder="Seleccione..."
            v-model="selectedItem"
            label="nombre"
          ></v-select>
        </div>
      </div>
    </td>
    <td>
      <div class="form-field">
        <input-field
          type="tel"
          v-mask="'##'"
          :id="'cantidad' + index"
          v-model="modelValue.cantidad"
          placeholder="Escriba la cantidad..."
        ></input-field>
      </div>
    </td>
    <td>
      <button
        class="btn-danger btn--text"
        type="button"
        @click="eliminar"
      >
        <i class="fa fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: function () {
        return {
          item_id: null,
          nombre: '',
          cantidad: 1
        }
      }
    },
    index: {
      type: Number,
      required: true,
    }
  },
  data: function() {
    return {
      modelValue: this.value,
      selectedItem: null,
      items: []
    };
  },
  methods: {
    onSearchItem: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.items = json;
          loading(false);
        } else loading(false);
      };
      let urlApi = `${url}/egreso-bodega/search-items?search=${search}`;
      xmlhttp.open("GET", urlApi, true);
      xmlhttp.send();
    },
    inputItem: function () {
      if(this.selectedItem != null) {
        this.modelValue.item_id = this.selectedItem.id;
        this.modelValue.nombre = this.selectedItem.nombre;
      }
      else {
        this.modelValue.item_id = null;
        this.modelValue.nombre = '';
      }
    },
    eliminar: function () {
      this.$emit("eliminar", this.index);
    }
  },
  mounted: function () {
    if (this.modelValue.item_id != null){
      this.selectedItem = {
        id: this.modelValue.item_id,
        nombre: this.modelValue.nombre,
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/inventario/TrEgresoBodega.vue